import React from "react";
import "./PrintRegistration.scss";
import moment from "moment";

const FormItem = ({ title, value }: { title: string, value: string }) => {
  return (
    <div className=""><span className="form-title">{title}:</span>{value ? value : ""}</div>
  )
}

const FormConatiner = ({ children }: { children: any }) => {
  return (
    <div className="d-flex align-items-start justify-content-between py-1">{children}</div>
  )
}

const FormGroup = ({ children }: { children: any }) => {
  return (
    <div className="flex-grow-1">{children}</div>
  )
}

const FormSection = ({ title, children, addBorder = true }: { title?: string, children: any, addBorder?: boolean }) => {
  return (
    <div className={`form-section ${addBorder ? "form-section-border" : ""}`}>
      {title && <div className="section-title">{title}</div>}
      {children}
    </div>
  )
}

function PrintRegistration({ printRef, patientDetail }: any) {
  let refByDoc = true
  if (patientDetail?.referredBy?.referredBy === "Doctor") {
    refByDoc = true
  }

  return (
    <div
      className="print-registration-wrapper" ref={printRef}>
      <div className="heading">Patient Registration Details</div>
      <div className="print-body">
        <FormSection title="Basic Information">
          <FormConatiner>
            <FormGroup>
              <FormItem
                title="Name"
                value={(patientDetail?.title || patientDetail?.firstName || patientDetail?.lastName) ?
                  `${patientDetail?.title} ${patientDetail?.isVIP ? "*****" : patientDetail?.firstName} ${patientDetail?.isVIP ? "*****" : patientDetail?.lastName}` : ""} />
              <FormItem title="Gender" value={patientDetail?.gender} />
            </FormGroup>
            <FormGroup>
              <FormItem
                title="Date of Birth"
                value={
                  patientDetail?.dob ?
                    moment(patientDetail?.dob).format(
                      "DD-MM-YYYY"
                    ) : ""
                } />
              <FormItem title="Age" value={patientDetail?.age} />
            </FormGroup>
          </FormConatiner>
        </FormSection>

        <FormSection title="Contact Information">
          <FormConatiner>
            <FormGroup>
              <FormItem title="Contact Number" value={patientDetail?.phoneNumber} />
              <FormItem title="Email" value={patientDetail?.email} />
            </FormGroup>
            <FormGroup>
              <FormItem title="Alternate Contact Number" value={patientDetail?.alternatePhoneNumber} />
              <FormItem title="Preferred Language" value={patientDetail?.additionalDetails?.languagePreferences} />
            </FormGroup>
          </FormConatiner>
        </FormSection>

        <FormSection title="Medical/Marital Information">
          <FormConatiner>
            <FormGroup>
              <FormItem title="Blood Group" value={patientDetail?.bloodGroup} />
              <FormItem title="Marital Status" value={patientDetail?.maritalStatus} />
            </FormGroup>
            <FormGroup>
              <FormItem
                title="Anniversary Date"
                value={patientDetail?.additionalDetails?.anniversaryDetails ?
                  moment(patientDetail?.additionalDetails?.anniversaryDetails).format(
                    "DD-MM-YYYY"
                  ) : ""
                } />
            </FormGroup>
          </FormConatiner>
        </FormSection>

        <FormSection title="Demographic Information">
          <FormConatiner>
            <FormGroup>
              <FormItem title="Nationality" value={patientDetail?.nationality} />
              <FormItem title="Occupation" value={patientDetail?.additionalDetails?.occupation} />
              <FormItem title="Annual Income" value={patientDetail?.annualIncome} />
            </FormGroup>
            <FormGroup>
              <FormItem title="Ethnicity" value={patientDetail?.ethnicity} />
              <FormItem title="Education Level" value={patientDetail?.educationLevel} />
            </FormGroup>
          </FormConatiner>
        </FormSection>

        <FormSection title="Address Information">
          <FormItem title="Line 1" value={patientDetail?.addressInfo?.addressLine1} />
          <FormItem title="Line 2" value={patientDetail?.addressInfo?.addressLine2} />
          <FormConatiner>
            <FormGroup>
              <FormItem title="Suburb" value={patientDetail?.addressInfo?.suburb} />
              <FormItem title="State" value={patientDetail?.addressInfo?.state} />
              <FormItem title="Enter Proof Document No" value={patientDetail?.governmentIdNo} />
            </FormGroup>
            <FormGroup>
              <FormItem title="District" value={patientDetail?.addressInfo?.district} />
              <FormItem title="Country" value={patientDetail?.addressInfo?.country} />
              <FormItem title="Pincode" value={patientDetail?.addressInfo?.pincode} />
            </FormGroup>
          </FormConatiner>
        </FormSection>

        <FormSection title="Reference Details">
          <FormConatiner>
            <FormGroup>
              <FormItem title="Referred By" value={patientDetail?.referredBy?.referredBy} />
              {refByDoc && <FormItem title="Name" value={patientDetail?.referredBy?.doctorName} />}
            </FormGroup>
            {refByDoc && (
              <FormGroup>
                <FormItem title="Speciality" value={patientDetail?.referredBy?.doctorSpeciality} />
                <FormItem title="Contact" value={patientDetail?.referredBy?.doctorContactNumber} />
              </FormGroup>
            )}
          </FormConatiner>
        </FormSection>

        <FormSection title="Responsible Person/Relative">
          <FormConatiner>
            <FormGroup>
              <FormItem title="Name" value={patientDetail?.responsiblePersonName} />
              <FormItem title="Contact" value={patientDetail?.responsiblePersonPhoneNumber} />
            </FormGroup>
            <FormGroup>
              <FormItem title="Relation" value={patientDetail?.responsiblePersonRelation} />
            </FormGroup>
          </FormConatiner>
        </FormSection>

        <FormSection title="For Office Use Only" addBorder={false}>
          <FormConatiner>
            <FormGroup>
              <FormItem title="Primary Consultant" value={patientDetail?.primaryConsultantName} />
              <FormItem title="Patient tag" value={patientDetail?.tags?.join()} />
            </FormGroup>
            <FormGroup>
              <FormItem title="Category" value={patientDetail?.category} />
              <FormItem title="Sub Category" value={patientDetail?.subCategory} />
            </FormGroup>
          </FormConatiner>
        </FormSection>
      </div>
    </div >
  )
}

export default PrintRegistration
